import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { DrawerLayoutWrapper } from 'common';
import ProgressBar from 'feature/dispatching/components/ProgressBar';
import DriversForm from './DriversForm';
import { useGetNewDriversForLocationQuery } from '../driverStatusEndpoints';

const lens = R.lensProp('drivers');

const Drivers = ({ onClose, next, driverState, setDriverState }) => {
  const { drivers } = driverState;
  const { viewById } = useParams();
  const { data = [], isLoading } = useGetNewDriversForLocationQuery({ locationId: +viewById });

  const isInvalid = R.o(R.gt(1), R.path(['drivers', 'length']))(driverState);

  const handleAdd = driver => {
    const over = R.append(driver);
    setDriverState(R.over(lens, over));
  };

  const handleRemove = driver => {
    const over = R.reject(R.equals(driver));
    setDriverState(R.over(lens, over));
  };

  const buttons = (
    <Box sx={{ display: 'flex', justifyContent: 'space-around', width: 1 }}>
      <Button disabled={isInvalid} onClick={next} sx={{ width: 150 }}>
        Submit
      </Button>
    </Box>
  );

  return (
    <DrawerLayoutWrapper
      buttons={buttons}
      headerButtonText="CLOSE"
      isLoading={isLoading}
      onHeaderButtonClick={onClose}
      title="Add Driver"
    >
      <ProgressBar
        label="Drivers (1 of 2)"
        sx={{
          '&.MuiLinearProgress-colorPrimary > .MuiLinearProgress-bar': {
            borderRadius: '10px',
          },
        }}
        value={50}
      />
      <Stack sx={{ mt: 3, width: 390 }}>
        <DriversForm
          drivers={drivers}
          onAdd={handleAdd}
          onRemove={handleRemove}
          selectableDrivers={data}
        />
      </Stack>
    </DrawerLayoutWrapper>
  );
};

Drivers.propTypes = {
  driverState: PropTypes.shape({
    drivers: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  next: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  setDriverState: PropTypes.func.isRequired,
};

export default Drivers;
